import Field from "./Field";

class EmailField extends Field {
    constructor(name) {
        super(name);
        this._type = "email";
    }
}

export default EmailField;



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./~/admin-config/lib/Field/EmailField.js
 **/